import makeStyles from "styles/muiStylesCompat/makeStyles";
import LinearProgress from "@mui/material/LinearProgress";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

export default function LinearIndeterminate() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LinearProgress />
    </div>
  );
}
